import keyMirror from 'react-utils/keyMirror';
export const PropertyObjectTypes = keyMirror({
  CONTACT: null,
  COMPANY: null,
  DEAL: null,
  TICKET: null,
  SHIPMENT: null,
  CUSTOM: null,
  FEEDBACK_SUBMISSION: null
});